// @ts-nocheck
import React, { Component } from 'react'
import PropTypes from 'prop-types'

class InputRange extends Component {
  constructor (props) {
    super(props)

    this.state = {
      step: this.props.stepJump || 2000,
      value: ''
    }

    this.OnChangeInputHandle = this.OnChangeInputHandle.bind(this)
    this.OnBlurInputHandle = this.OnBlurInputHandle.bind(this)
  }

  // #region ["Event Listiners"]

  OnChangeInputHandle = e => this.setState({ value: parseInt(e.target.value) })

  OnBlurInputHandle = () => this.CallbackPointsToComponent(this.state.value)

  CallbackPointsToComponent (value) {
    this.props.handlerValueSelected(value)
  }

  // #endregion

  render () {
    return (
      <div className='form-field px-0 stix-quantity form-field'>
        <input
          type='number'
          className='no-label qtd-points'
          placeholder='Qtd.'
          aria-label='Quantidade'
          disabled={this.props.disabled}
          min={this.props.minimunValue}
          max={this.props.maximunValue}
          value={this.state.value}
          step={this.state.step}
          onChange={this.OnChangeInputHandle}
          onBlur={this.OnBlurInputHandle}
        />
        <div
          className='pos-absolute t-0 r-0 h-100 d-flex align-items-center border border-ui-3 px-1 bg-white'
        >
          <p className='txt-bold txt-lowercase'>{this.props.pointsName}</p>
        </div>
      </div>
    )
  }
}

InputRange.propTypes = {
  minimunValue: PropTypes.number,
  maximunValue: PropTypes.number,
  stepJump: PropTypes.number,
  handlerValueSelected: PropTypes.func,
  disabled: PropTypes.bool,
  pointsName: PropTypes.string
}

export default InputRange



// WEBPACK FOOTER //
// ./src/features/Stix/InputRange.js